module.exports = __webpack_public_path__ + "img/ChildFriendlyOutlined.a2677446.svg";